export const FIND_SIMILAR_SERVICE_HOST = 'https://wims-find-similar.winglegroup.com';

export const FIND_SIMILAR_PATHS = {
  similarProducts: `${FIND_SIMILAR_SERVICE_HOST}/api/products`,
};
